var styles = {"title":"EmailVerification_title_1j144_1","mail":"EmailVerification_mail_1j144_14","verify":"EmailVerification_verify_1j144_26"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
